/**
 * Mounts the first-run product tour overlay.
 *
 * Uses the `useTour()` hook to decide whether to render `<Tour>`. Because
 * `<Tour>` portals to `document.body`, this provider is intentionally
 * structural — it has no DOM output of its own and can sit anywhere inside
 * the auth/query providers (we mount it from the root route's `Layout`).
 *
 * The overlay does NOT block routing; if a child route navigates while the
 * tour is open, the tour stays mounted and the new route renders behind the
 * spotlight (which then re-resolves against the new DOM on the next step).
 */
import type { ReactNode } from 'react'
import { Tour } from './Tour'
import { useTour } from './use-tour'

export function TourProvider({ children }: { children: ReactNode }) {
  const { active, steps, dismiss } = useTour()
  return (
    <>
      {children}
      {active ? <Tour steps={steps} onComplete={dismiss} /> : null}
    </>
  )
}
